import { Values } from "./helpers";

export type SortDirection = Values<typeof SORT_DIRECTIONS>;

export const SORT_DIRECTIONS = {
  asc: "Asc",
  desc: "Desc",
} as const;
